export function isArrayNullOrEmpty<T>(array: T[] | null | undefined) : array is null | undefined {
    return array == null || array == undefined || array.length == 0;
}


// WEBPACK FOOTER //
// ./src/utils/array.ts